





















import Vue from "vue";
import Component from "vue-class-component";
import SarsTable from "@/components/layout/tables/SarsTable.vue";
import VesselsTable from "@/components/layout/tables/VesselsTable.vue";
import OilRigsTable from "@/components/layout/tables/OilRigsTable.vue";

@Component({
  components: {
    SarsTable,
    VesselsTable,
    OilRigsTable,
  },
})
export default class SearchCard extends Vue {
  tab: any = null;
}
